import { createStore, combineReducers } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { modal, language } from "./reducers";

export default createStore( combineReducers({ modal, language }), composeWithDevTools())
